<script lang="ts">
export default {
    name: 'IntentionsListButtons',
    components: {},
    props: {
        item: { type: Object, required: true },
        translationName: { type: String, required: true },
    },
    emits: ['viewRoute', 'updateRoute', 'deleteItem'],
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
}
</script>

<template>
    <v-btn
        v-if="item && $permissionCheck(`voirie_intention_show`)"
        variant="text" prepend-icon="mdi-eye" size="x-small" density="compact"
        color="primary"
        @click="$emit('viewRoute', item)"
    >
        Voir
    </v-btn>
    <br>
    <v-btn
        v-if="item && $permissionCheck(`voirie_intention_update`) && item.meta.editable"
        variant="text" prepend-icon="mdi-pencil" size="x-small" density="compact"
        color="primary"
        @click="$emit('updateRoute', item)"
    >
        Modifier
    </v-btn>

    <ListDeleteConfirmation
        v-if="item && $permissionCheck(`voirie_intention_destroy`) && item.meta.deletable"
        :item="item"
        :translation-name
        button="<v-btn variant='text' prepend-icon='mdi-delete' size='x-small' density='compact' color='primary'>Supprimer</v-btn>"
        @delete-data="$emit('deleteItem')"
    />
</template>
